import FormTask from 'components/task/types/form/FormTask';

export default {
	'components.FormTask': {
		factory: FormTask,
		deps: [{ $ref: 'components.task.layout.BaseLayout' }],
	},
};
